import React from "react";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import CardSubtitle from "./card/CardSubtitle";

const CustomCard = ({items = [], variant = "default", alignment = "vertical", linked = false}) => {
    return (
        <div className={"cards"}>
            {items.map((item, index) => {
                const cardContent = (
                    <>
                        {item?.imagePath && (
                            <CardMedia
                                className={"custom-card-image skeleton"}
                                component="img"
                                image={item?.imagePath}
                                alt="card-image"
                                style={{objectPosition: item?.position || "center"}}
                                loading={"lazy"}
                            />
                        )}
                        <div className={"custom-card-content-wrapper"}>
                            <CardContent className={"custom-card-content"}>
                                {item?.title && <h3 className={"custom-card-title"}>{item?.title}</h3>}
                                {item?.subtitle && <CardSubtitle variant={variant} subtitle={item?.subtitle} />}
                                {item?.description && (
                                    <div
                                        className={"custom-card-description"}
                                        dangerouslySetInnerHTML={{__html: item?.description}}
                                    />
                                )}
                            </CardContent>
                            {!linked && item?.ctaUrl && (
                                <CardActions className={"custom-card-actions"}>
                                    <Button
                                        className={"button hover-move"}
                                        variant="contained"
                                        href={item?.ctaUrl}
                                        target={"_blank"}
                                        rel="noreferrer"
                                        onClick={() => window.umami?.track("Card Click", { label: item?.title })}
                                    >
                                        {item?.ctaText}
                                    </Button>
                                </CardActions>
                            )}
                        </div>
                    </>
                );

                return (
                    <Card
                        className={`custom-card ${variant} ${alignment} ${linked ? "linked" : ""}`}
                        key={index}
                        component={linked ? "a" : "div"}
                        href={linked ? item?.ctaUrl : undefined}
                        target={linked ? "_blank" : undefined}
                        rel={linked ? "noreferrer" : undefined}
                        style={linked ? {cursor: "pointer"} : undefined}
                        onClick={linked ? () => window.umami?.track("Card Click", { label: item?.title }) : undefined}
                    >
                        {cardContent}
                    </Card>
                );
            })}
        </div>
    );
};

export default CustomCard;
